
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from '../../project_config';
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import Header from "../common/header/Header";

export default function PrivacyAndPolicy() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(() => window.innerWidth > 768);

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'قوانین و مقررات', href: '/privacy_and_policy/' },
	];

	return (
		<>
			<Helmet>
				<title>قوانین و مقررات | همراهتیم</title>
				<meta name="description" content="قوانین و مقررات استفاده از سامانه همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[600px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[40px]" />
					<article
						className={`${isDesktop ? 'w-[720px]' : 'px-4'} mx-auto bg-white rounded-[16px] shadow-sm p-6 md:p-10`}
					>
						<h1 className="font-Vazir-800 text-[24px] md:text-[28px] text-darkBlue text-center mb-8">
							قوانین و مقررات
						</h1>
						<div className="font-Vazir-400 text-[15px] md:text-[16px] leading-[2] text-[#4B5155] text-center space-y-6">
							<p>
								همراهتیم یک سامانه جامع در حوزه روان میباشد و رسالت اصلی این
								سامانه کمک به بیماران و روان در مانگران جهت اتصال این دو بهم
								میباشد.
							</p>
							<p>
								لازم به ذکر است که تمامی اطلاعات بیماران و دیگر کاربران این
								سامانه کاملا محرمانه میباشد و مسئولیت هر گونه نشت داده با
								وبسایت همراهتیم میباشد.
							</p>
							<p>
								چنانچه قصد استفاده از سامانه همراهتیم را دارید ورود شما به
								معنی پذیرش قوانین و مقررات همراهتیم است.
							</p>
						</div>
					</article>
					<div className="spacer p-[40px]" />
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
